import { facilitiesQueryAtom } from '../_graphql/queryFacilities';

// 🟢🟢🟢 REMOTE DATA - Facilities
export const $remoteFacilities = facilitiesQueryAtom(() => ({
  variables: {} as never,
  lazy: true,
}));
